function FlickityCarousel(element, options) {
  if (typeof element === 'string') element = document.querySelector(element);
  if (!element) return;
  this.element = element;
  this.options = Object.assign({
    contain: true, pageDots: true, prevNextButtons: true,
    wrapAround: false, autoPlay: false, fade: false,
    cellAlign: 'center', resize: true, touchVerticalScroll: true,
    selectedAttraction: 0.025, friction: 0.28, dragThreshold: 3,
    asNavFor: null, cellSelector: null, pauseAutoPlayOnHover: true
  }, options || {});
  this.selectedIndex = 0;
  this.cells = [];
  this.listeners = {};
  this._autoPlayTimer = null;
  this._navFor = null;
  element._flickity = this;
  this.$element = [element];
  this._init();
}

FlickityCarousel.prototype._init = function () {
  var el = this.element;
  var self = this;
  if (this.options.cellSelector) {
    this.cells = Array.from(el.querySelectorAll(this.options.cellSelector));
  } else {
    this.cells = Array.from(el.children);
  }
  if (this.cells.length === 0) return;
  el.classList.add('yv-carousel', 'flickity-enabled');
  if (this.options.fade) el.classList.add('yv-carousel-fade');
  this.cells.forEach(function (cell, i) {
    cell.classList.add('yv-carousel-cell');
    if (i === 0) cell.classList.add('is-selected');
  });
  if (this.options.pageDots && this.cells.length > 1) {
    this._dotsEl = document.createElement('div');
    this._dotsEl.className = 'flickity-page-dots';
    this.cells.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'flickity-page-dot' + (i === 0 ? ' is-selected' : '');
      dot.setAttribute('aria-label', 'Page ' + (i + 1));
      dot.addEventListener('click', function () { self.select(i); });
      self._dotsEl.appendChild(dot);
    });
    el.parentNode.insertBefore(this._dotsEl, el.nextSibling);
  }
  if (this.options.prevNextButtons && this.cells.length > 1) {
    this._prevBtn = document.createElement('button');
    this._prevBtn.className = 'flickity-button flickity-prev-next-button previous';
    this._prevBtn.setAttribute('aria-label', 'Previous');
    this._prevBtn.innerHTML = '<svg viewBox="0 0 100 100"><path d="M65 20L35 50l30 30" fill="none" stroke="currentColor" stroke-width="8"/></svg>';
    this._nextBtn = document.createElement('button');
    this._nextBtn.className = 'flickity-button flickity-prev-next-button next';
    this._nextBtn.setAttribute('aria-label', 'Next');
    this._nextBtn.innerHTML = '<svg viewBox="0 0 100 100"><path d="M35 20l30 30-30 30" fill="none" stroke="currentColor" stroke-width="8"/></svg>';
    el.appendChild(this._prevBtn);
    el.appendChild(this._nextBtn);
    this._prevBtn.addEventListener('click', function () {
      self.select(self.selectedIndex - 1);
    });
    this._nextBtn.addEventListener('click', function () {
      self.select(self.selectedIndex + 1);
    });
  }
  if (!this.options.fade) {
    this._scrollHandler = function () {
      if (self._scrollTimeout) clearTimeout(self._scrollTimeout);
      self._scrollTimeout = setTimeout(function () {
        var scrollLeft = el.scrollLeft;
        var cellWidth = el.offsetWidth;
        var idx = Math.round(scrollLeft / cellWidth);
        if (idx !== self.selectedIndex) {
          self.selectedIndex = idx;
          self._updateSelected();
          self._emit('change', idx);
        }
      }, 100);
    };
    el.addEventListener('scroll', this._scrollHandler);
  }
  if (this.options.asNavFor) {
    var navEl = document.querySelector(this.options.asNavFor);
    if (navEl && navEl._flickity) {
      this._navFor = navEl._flickity;
      navEl._flickity._navFor = this;
    }
    this.element.addEventListener('click', function (e) {
      var cell = e.target.closest('.yv-carousel-cell');
      if (cell) {
        var idx = self.cells.indexOf(cell);
        if (idx >= 0 && self._navFor) self._navFor.select(idx);
      }
    });
  }
  this._startAutoPlay();
  if (this.options.resize) {
    this._resizeHandler = function () { self.resize(); };
    window.addEventListener('resize', this._resizeHandler);
  }
};

FlickityCarousel.prototype.select = function (index) {
  if (this.cells.length === 0) return;
  if (this.options.wrapAround) {
    index = ((index % this.cells.length) + this.cells.length) % this.cells.length;
  } else {
    index = Math.max(0, Math.min(index, this.cells.length - 1));
  }
  if (index === this.selectedIndex && this.cells[index].classList.contains('is-selected')) return;
  this.selectedIndex = index;
  if (this.options.fade) {
    this._updateSelected();
  } else {
    var target = this.cells[index];
    if (target) {
      this.element.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }
  }
  this._updateSelected();
  this._emit('change', index);
  this._resetAutoPlay();
  if (this._navFor) {
    this._navFor.selectedIndex = index;
    this._navFor._updateSelected();
    if (!this._navFor.options.fade) {
      var t = this._navFor.cells[index];
      if (t) this._navFor.element.scrollTo({ left: t.offsetLeft, behavior: 'smooth' });
    }
  }
};

FlickityCarousel.prototype._updateSelected = function () {
  var self = this;
  this.cells.forEach(function (cell, i) {
    cell.classList.toggle('is-selected', i === self.selectedIndex);
  });
  if (this._dotsEl) {
    Array.from(this._dotsEl.children).forEach(function (dot, i) {
      dot.classList.toggle('is-selected', i === self.selectedIndex);
    });
  }
};

FlickityCarousel.prototype._emit = function (eventName, data) {
  var cbs = this.listeners[eventName];
  if (cbs) cbs.forEach(function (cb) { cb.call(null, data); });
  if (this.element) {
    this.element.dispatchEvent(new CustomEvent(eventName, { detail: data, bubbles: true }));
  }
};

FlickityCarousel.prototype.on = function (eventName, cb) {
  var name = eventName.replace('.flickity', '');
  if (!this.listeners[name]) this.listeners[name] = [];
  this.listeners[name].push(cb);
};

FlickityCarousel.prototype.off = function (eventName, cb) {
  var name = eventName.replace('.flickity', '');
  if (this.listeners[name]) {
    this.listeners[name] = this.listeners[name].filter(function (fn) { return fn !== cb; });
  }
};

FlickityCarousel.prototype._startAutoPlay = function () {
  var self = this;
  if (this.options.autoPlay && typeof this.options.autoPlay === 'number') {
    this._autoPlayTimer = setInterval(function () {
      self.select(self.selectedIndex + 1);
    }, this.options.autoPlay);
  }
};

FlickityCarousel.prototype._resetAutoPlay = function () {
  if (this._autoPlayTimer) clearInterval(this._autoPlayTimer);
  this._startAutoPlay();
};

FlickityCarousel.prototype.resize = function () {};
FlickityCarousel.prototype.updateDraggable = function () {};

FlickityCarousel.prototype.destroy = function () {
  if (this._autoPlayTimer) clearInterval(this._autoPlayTimer);
  if (this._scrollHandler) this.element.removeEventListener('scroll', this._scrollHandler);
  if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
  this.element.classList.remove('yv-carousel', 'yv-carousel-fade', 'flickity-enabled');
  this.cells.forEach(function (cell) {
    cell.classList.remove('yv-carousel-cell', 'is-selected');
  });
  if (this._dotsEl) this._dotsEl.remove();
  if (this._prevBtn) this._prevBtn.remove();
  if (this._nextBtn) this._nextBtn.remove();
  this.listeners = {};
  delete this.element._flickity;
};

FlickityCarousel.data = function (element) {
  if (typeof element === 'string') element = document.querySelector(element);
  return element && element._flickity ? element._flickity : null;
};

var Flickity = FlickityCarousel;

function flickityMethod(el, method, arg) {
  var instance = el && el._flickity;
  if (!instance) return;
  if (method === 'select') instance.select(arg);
  else if (method === 'destroy') instance.destroy();
  else if (method === 'resize') instance.resize();
  else if (method === 'previous') instance.select(instance.selectedIndex - 1);
  else if (method === 'next') instance.select(instance.selectedIndex + 1);
  else if (typeof instance[method] === 'function') instance[method](arg);
}
